var map = {
	"./add.svg": "76a4",
	"./align-center.svg": "86d7",
	"./align-justify.svg": "e45d",
	"./align-left.svg": "d4aa",
	"./align-right.svg": "7526",
	"./arrow-down.svg": "c874",
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./arrow-up.svg": "a3f8",
	"./check-circle.svg": "cfcb",
	"./check.svg": "7bae",
	"./chevron-down.svg": "1755",
	"./chevron-left.svg": "d0fe",
	"./chevron-right.svg": "88ee",
	"./chevron-up.svg": "bb5d",
	"./chevrons-down.svg": "36a4c",
	"./chevrons-left.svg": "d836",
	"./chevrons-right.svg": "04a9",
	"./chevrons-up.svg": "98a7",
	"./facebook.svg": "8485",
	"./hamburger.svg": "f5d5",
	"./home.svg": "ac9d",
	"./info-circle.svg": "6668",
	"./instagram.svg": "bd6c",
	"./message.svg": "612e",
	"./more-horizontal.svg": "6988",
	"./search.svg": "d103",
	"./shopping-cart.svg": "b15e",
	"./twitter.svg": "acf9",
	"./x.svg": "73875"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";